<template>
  <div
    v-if="fields"
    class="py-10"
  >
    <v-divider v-if="fields.divider === 'top'" />
    <div
      v-if="!fields.hideHeadings"
      class="mx-auto mb-12 text-center"
      style="max-width: 536px;"
    >
      <h2 class="secondary--text h3">
        {{ fields.heading }}
      </h2>
      <p class="mt-5">
        {{ fields.subHeading }}
      </p>
    </div>
    <div class="d-flex justify-center">
      <router-link
        v-if="fields.onlyThreeMostRecent && eventsPageLink"
        :to="eventsPageLink"
        class="text-decoration-none hover-icon-right mb-10"
      >
        <strong>
          See all events
          <v-icon
            :color="color === 'error' ? 'gold' : 'accent'"
            postfix
          >
            arrow_forward
          </v-icon>
        </strong>
      </router-link>
    </div>
    <div class="d-flex justify-center">
      <div
        v-if="sortedEntries && sortedEntries.length"
        class="events-grid-wrapper"
        :style="{ 'grid-template-columns': `repeat(${sortedEntries.length}, minmax(auto, 381px))` }"
      >
        <div
          v-for="(event, i) of sortedEntries"
          :key="'event-group-item-' + event.fields.name + '_' + i"
          role="group"
        >
          <event-item
            v-if="i < pageCount"
            :event="event"
            :is-past="isPast"
            :color="color"
          />
        </div>
      </div>
    </div>
    <v-row justify="center">
      <base-button
        v-if="sortedEntries.length > pageCount"
        text="load more"
        inverted
        @click="pageCount += 10"
      />
    </v-row>
    <v-divider v-if="fields.divider === 'bottom'" />
    <pixel-tracker
    v-if="siteConfig.careNetworkName.indexOf('Vermont') == -1"
    :cid="601117795"
    :clabel="jDOGCKaC_dsBEOOo0Z4C"
     />
    <pixel-tracker
    v-else
    :cid="608189871"
    :clabel="mzYZCLK2qNkBEK_7gKIC"
     />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { queryCTF, getCTFAsset } from '@/plugins/contentful'
import EventItem from '@/components/slices/events/event-item'
import PixelTracker from '@/components/base/pixel-tracker'

export default {
  name: 'EventItemGroup',
  components: {
    EventItem,
    PixelTracker
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    onlySimilar: {
      // Will filter only similar events. Used by event detail page and will override fields.isPast
      type: Boolean,
      default: null
    },
    tags: {
      // If onlySimilar is true, then the most recent 3 events with any of these tags are shown.
      // Current tags are ['upcoming', 'virtual']
      type: Array,
      default: null
    }
  },
  data () {
    return {
      sortedEntries: [],
      dialog: false,
      selectedLink: '',
      pageCount: 10
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    eventsPageLink () {
      if ((!this.fields || !this.fields.eventsPageLink) || !this.siteConfig) {
        return null
      }
      const eventsPage = this.siteConfig.pages.find(p => p.id === this.fields.eventsPageLink.sys.id)
      return (eventsPage) ? eventsPage.route : null
    },
    isPast () {
      return this.fields.timeFrame === 'past'
    },
    color () {
      return this.siteConfig.navBottomBorderColor === 'orange'
        ? 'error'
        : 'accent'
    }
  },
  async created () {
    let { items, includes } = await queryCTF(
      '&content_type=event&select.fields'
    )
    items = items.filter(x =>
      x.fields.sites.some(y => y.sys.id === this.siteConfig.id)
    )
    if (this.onlySimilar) {
      items = this.filterSimilarEvents(items)
    } else if (this.isPast) {
      items = items.filter(event => new Date(event.fields.date) < new Date())
    } else {
      items = items.filter(event => new Date(event.fields.date) >= new Date())
    }
    let sortedEvents = items.sort(
      (a, b) => new Date(a.fields.date) - new Date(b.fields.date)
    )
    sortedEvents = sortedEvents.map(event => {
      const {
        fields: { file }
      } = getCTFAsset(event.fields.thumbnail.sys.id, includes.Asset)
      event.file = file
      return event
    })
    if (this.fields.onlyThreeMostRecent || this.onlySimilar) {
      sortedEvents = sortedEvents.slice(0, 3)
    }
    this.sortedEntries = sortedEvents
  },
  methods: {
    /** Returns only events that have exactly the same tags as this.tags */
    filterSimilarEvents (items) {
      if (!this.tags) {
        return items
      }
      return items.filter(i => {
        if (!i.fields.tags) {
          return false
        }
        const one = i.fields.tags.every(e => this.tags.includes(e))
        const two = this.tags.every(e => i.fields.tags.includes(e))
        return one && two
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";

.events-grid-wrapper {
  display: grid;
  grid-template-rows: repeat(auto-fill, 1fr);
  grid-gap: 60px 27px;
}

@media (max-width: $breakpoint-md) {
  .events-grid-wrapper {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: $breakpoint-sm) {
  .events-grid-wrapper {
    grid-template-columns: repeat(1, 1fr) !important;
    grid-gap: 40px 27px;
  }
}
</style>
